/* eslint-disable class-methods-use-this */
import React from 'react';
import PaymentRedsysFormConnector from '../../../containers/checkout-steps/payment-redsys-form-connector';
import spreeStore from '../../../store';
import generalCss from '../../styles/components/checkout-steps/payment/payment-method-selector.scss';

class PaymentMethodRedsys extends React.Component {
    constructor(props) {
        super(props);
        this.redsysFormRef = React.createRef();
    }

    onNext() {
        this.redsysFormRef.current.querySelector('form').submit();
    }

    selectionToggle() {
        if (this.props.onOptionSelected) {
            window.scrollTo(0, 0);
            this.props.onOptionSelected(this.props.method);
        }
    }

    isThisOptionSelected() {
        return this.props.method && this.props.optionSelected && this.props.method.id === this.props.optionSelected.id;
    }

    shouldNextBeEnabled() {
        const { order } = spreeStore.getState();
        if (order.redsysPaymentInfo.Ds_MerchantParameters) {
            return true;
        }
        return false;
    }

    render() {
        return (
            <div>
                <div>
                    <input
                        type="radio"
                        id={this.props.method.id}
                        name="payment_method"
                        value={this.props.method.name}
                        onChange={() => {
                            this.selectionToggle();
                        }}
                        defaultChecked={this.props.method.isDefault}
                    />
                    <label className={generalCss.pms__option__label} htmlFor={this.props.method.id}>{this.props.method.name}</label>
                </div>
                {this.isThisOptionSelected() && (
                    <div ref={this.redsysFormRef} style={{ display: 'none' }}>
                        <PaymentRedsysFormConnector />
                    </div>
                )}
            </div>
        );
    }
}

export default PaymentMethodRedsys;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment/payment-method-redsys.js
 **/